export default __webpack_public_path__ + "719cbd045d95d8d67c056baa5f58f4a8.png";